import React from 'react';
import { HelpText, TextInput } from 'src/components/atoms';
import { FormState } from 'src/types';
import { ExternalOffenderChipList } from './ExternalOffenderChipList';

interface ExternalOffenderInputProps {
  allowMultiSelect: boolean;
  inputValue: string;
  onInputChange: (value: string) => void;
  onCommit: () => void;
  externalNames: string[];
  onRemove: (name: string) => void;
  baseTestId: string;
}

export const ExternalOffenderInput: React.FC<ExternalOffenderInputProps> = ({
  allowMultiSelect,
  inputValue,
  onInputChange,
  onCommit,
  externalNames,
  onRemove,
  baseTestId,
}) => (
  <>
    {!allowMultiSelect && (
      <HelpText
        state={FormState.DEFAULT}
        helpText="Only one external name can be entered"
        data-testid={`${baseTestId}-single-select-hint`}
        textSize="medium"
        $margin="0"
      />
    )}
    <TextInput
      state={FormState.DEFAULT}
      value={inputValue}
      onChange={(e) => onInputChange(e.target.value)}
      onBlur={onCommit}
      onKeyDown={(e) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        onCommit();
      }}
      placeholder={
        allowMultiSelect ? 'Enter name(s), separated by commas' : 'Enter name'
      }
      data-testid={`${baseTestId}-external-offender-input`}
    />
    <ExternalOffenderChipList
      names={externalNames}
      onRemove={onRemove}
      dataTestId={baseTestId}
    />
  </>
);
